import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import SaveAsModal from './SaveAsModal';
import { TabbedFilters } from '../../../components/Filters';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
import ModuleExport from '../../../components/ModuleExport';

const TopBar = ({
  loading,
  uuid,
  reportUserId,
  handleSaveNewReport,
  handleSaveReport,
  userId,
  onClickRun,
  isStateGenerated,
  showContentTypes,
  showNetworks,
  showStudios,
  hasData,
  reportName,
  downloadFunc,
  disableSaveAs,
  filtersActions: { updateFilters, clearFilter, clearFilters },
  reportBuilderActions: { ignoreCustomViewRequest }
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const [showSaveAsModal, setShowSaveAsModal] = useState(false);

  const handleCloseModal = () => setShowSaveAsModal(false);

  const handleFilterApply = props => {
    updateFilters(props, { syncWithUrl: false });
    setHasChanges(true);
  };

  const onClickSave = () => setShowSaveAsModal(true);

  const handleFilterClear = props => {
    clearFilter(props);
    setHasChanges(true);
  };

  const handleFilterClearAll = props => {
    clearFilters(props);
    setHasChanges(true);
  };
  return (
    <div className="tvt-report-builder__filters">
      <SaveAsModal
        name={reportName}
        isOpen={showSaveAsModal}
        onClose={handleCloseModal}
        onSave={handleSaveNewReport}
      />
      <div className="tvt-report-builder__filters-item">
        <TabbedFilters
          loading={loading}
          showContentTypes={showContentTypes}
          showNetworks={showNetworks}
          showStudios={showStudios}
          hideGroup={!hasChanges || loading}
          onApply={handleFilterApply}
          onClear={handleFilterClear}
          onClearAll={handleFilterClearAll}
          autoApply
        />
      </div>
      <div className="tvt-report-builder__filters-item">
        <div className="tvt-report-builder__operations">
          {!loading && (
            <Button
              className={classnames('tvt-report-builder__save', {
                inactive: isStateGenerated
              })}
              onClick={onClickRun}
              disabled={isStateGenerated}
            >
              Run
            </Button>
          )}
          {loading && (
            <Button
              className="tvt-report-builder__save"
              onClick={ignoreCustomViewRequest}
            >
              <LoadingSpinner />
              Cancel
            </Button>
          )}
          {!isEmpty(uuid) && !isEmpty(reportUserId) && reportUserId === userId && (
            <Button
              className="tvt-report-builder__save-as"
              onClick={handleSaveReport}
              disabled={loading}
            >
              Save
            </Button>
          )}
          <Button
            disabled={disableSaveAs}
            className="tvt-report-builder__save-as"
            onClick={onClickSave}
          >
            Save As
          </Button>
          {hasData && !loading && isStateGenerated && (
            <ModuleExport
              fetchData
              customDownloadFunc
              tableDataDownload={downloadFunc}
              data={() => {}}
              title="Custom Report"
              showTitle="Custom Report"
              csv
              xls
              png
            />
          )}
        </div>
      </div>
    </div>
  );
};

TopBar.propTypes = {
  loading: PropTypes.bool.isRequired,
  uuid: PropTypes.string.isRequired,
  reportUserId: PropTypes.string,
  handleSaveNewReport: PropTypes.func.isRequired,
  handleSaveReport: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  onClickRun: PropTypes.func.isRequired,
  isStateGenerated: PropTypes.bool.isRequired,
  showContentTypes: PropTypes.bool.isRequired,
  showNetworks: PropTypes.bool.isRequired,
  showStudios: PropTypes.bool.isRequired,
  hasData: PropTypes.bool.isRequired,
  reportName: PropTypes.string,
  downloadFunc: PropTypes.func.isRequired,
  disableSaveAs: PropTypes.bool.isRequired,
  filtersActions: PropTypes.shape({
    clearFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired
  }).isRequired,

  reportBuilderActions: PropTypes.shape({
    ignoreCustomViewRequest: PropTypes.func.isRequired
  }).isRequired
};

TopBar.defaultProps = {
  reportUserId: '',
  reportName: ''
};

export default TopBar;
